import { apiClient } from "./client";

function reauthenticationBody({ password, credential } = {}) {
  if (credential) return { credential };
  if (password) return { password };
  return {};
}

async function blobToJson(blob) {
  const text = await blob.text();
  return text ? JSON.parse(text) : {};
}

export async function requestPrivacyExport(reauthentication) {
  const response = await apiClient.post(
    "/auth/privacy/export",
    reauthenticationBody(reauthentication),
    { responseType: "blob" }
  );
  if (response.status === 202) {
    const payload = await blobToJson(response.data);
    return { pending: true, ...payload };
  }
  const disposition = response.headers["content-disposition"] || "";
  const matchedFilename = disposition.match(/filename\*?=(?:UTF-8''|["']?)([^"';]+)/i);
  return {
    pending: false,
    blob: response.data,
    filename: matchedFilename ? decodeURIComponent(matchedFilename[1]) : "stocksleuth-data.json"
  };
}

export async function requestAccountErasure(reauthentication) {
  const response = await apiClient.delete("/auth/account", {
    data: {
      ...reauthenticationBody(reauthentication),
      confirmation: "DELETE MY ACCOUNT"
    }
  });
  return response.data;
}

export async function getPrivacyRequest(requestId) {
  return (await apiClient.get(`/auth/privacy/requests/${encodeURIComponent(requestId)}`)).data;
}
